import { useMemo, useRef, useState } from 'react';
import { AppUser } from '../../pm/types';
import { displayName } from '../../pm/constants';
import PortalMenu from './PortalMenu';

interface Props {
  ownerId: string;
  admins: AppUser[]; // full user pool; we filter to admins inside
  onChange: (uid: string) => void;
}

const OwnerPicker: React.FC<Props> = ({ ownerId, admins: users, onChange }) => {
  const admins = useMemo(() => users.filter((u) => u.isOperator), [users]);
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLSpanElement | null>(null);

  const currentEmail = admins.find((a) => a.uid === ownerId)?.email;
  const pillClass = ownerId
    ? 'pm-pill pm-owner'
    : 'pm-pill pm-owner-unassigned';
  const label = ownerId ? displayName(currentEmail) : 'Unassigned';

  function pick(uid: string) {
    onChange(uid);
    setOpen(false);
  }

  return (
    <span className="pm-owner-wrap" ref={triggerRef}>
      <span
        className={pillClass}
        onClick={() => setOpen((v) => !v)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setOpen((v) => !v); }}
      >
        {label}
      </span>
      <PortalMenu
        open={open}
        triggerRef={triggerRef}
        onDismiss={() => setOpen(false)}
        className="pm-owner-menu"
        estimatedHeight={(admins.length + 1) * 36 + 16}
      >
        <button
          className={ownerId === '' ? 'active' : ''}
          onClick={() => pick('')}
        >
          Unassigned
        </button>
        {admins.map((a) => (
          <button
            key={a.uid}
            className={a.uid === ownerId ? 'active' : ''}
            onClick={() => pick(a.uid)}
          >
            {a.email}
          </button>
        ))}
        {admins.length === 0 ? (
          <button disabled style={{ color: 'var(--pm-text-dim)', cursor: 'default' }}>
            No admins available
          </button>
        ) : null}
      </PortalMenu>
    </span>
  );
};

export default OwnerPicker;
